import './App.css'
import {Switch, Route, Redirect} from 'react-router-dom'
import {Component} from 'react'
import Home from './Home'
import Login from './Login'
import ProtectedRoute from './ProtectedRoute'
import ThemeContext from './ThemeContext'
import NotFound from './NotFound'
import SavedVideo from './SavedVideo'
import Trending from './Trending'
import VideoItemDetails from './VideoItemDetails'
import Gaming from './Gaming'

// Replace your code here
class App extends Component {
  state = {activeThemeIsLight: true, savedVideos: []}

  toSavedVideos = video => {
    const {savedVideos} = this.state
    const isIncludes = savedVideos.find(each => each.id === video.id)
    if (isIncludes === undefined) {
      this.setState(prev => ({savedVideos: [...prev.savedVideos, video]}))
    } else {
      const newList = savedVideos.filter(each => each.id !== video.id)
      this.setState({savedVideos: newList})
    }
  }

  toChangeTheme = () => {
    this.setState(prev => ({activeThemeIsLight: !prev.activeThemeIsLight}))
  }

  render() {
    const {activeThemeIsLight, savedVideos} = this.state
    return (
      <>
        <ThemeContext.Provider
          value={{
            activeThemeIsLight,
            toChangeTheme: this.toChangeTheme,
            savedVideos,
            toSaveVideo: this.toSavedVideos,
          }}
        >
          <Switch>
            <Route exact path="/login" component={Login} />
            <ProtectedRoute exact path="/" component={Home} />
            <ProtectedRoute exact path="/trending" component={Trending} />
            <ProtectedRoute exact path="/gaming" component={Gaming} />
            <ProtectedRoute exact path="/saved-videos" component={SavedVideo} />
            <ProtectedRoute
              exact
              path="/videos/:id"
              component={VideoItemDetails}
            />
            <Route path="/not-found" component={NotFound} />
            <Redirect to="/not-found" />
          </Switch>
        </ThemeContext.Provider>
      </>
    )
  }
}

export default App
